import Vue from "vue";


const success = (context) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal("Deleted!", "Your imaginary user has been deleted!", "success");
  context.loading = false;
  Vue.router.push({
    name: 'account.team',
  });
};

const failed = (context, error) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal("Error!", error.response.data.msg, "warning");
  //this.error = error.response.data.msg;
  toastr.error(error.response.data.msg);
  context.loading = false;
};

export default (context, id) => Vue.$http.delete(`/sub-users/${id}`).then((response) => {
  if (response && response.status === 200) {
    success(context);
  }
}).catch((error) => {
  if (error.response) {
    failed(context, error);
  }
});



// WEBPACK FOOTER //
// ./src/app/services/account/deleteSubUsers.js